/** Strings the landing promo film spells for playback and sound controls. */
export const heroVideoCopy = {
  ariaLabel: 'MemeOn in 50 seconds: mint a meme, watch it climb the virality tiers, trade it.',
  play: 'Play the 50-second tour',
  soundOn: 'Sound on',
  soundOff: 'Sound off',
  unmute: 'Unmute the video',
  mute: 'Mute the video',
} as const
